// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2slki","noInteraction":"EventWrapper_noInteraction__2zJhs"};